import { Component, OnInit, inject } from '@angular/core';
import { TitleService } from '../../../common/services/title.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  standalone: false
})
export class UserManagementComponent implements OnInit {
  private titleService = inject(TitleService);
  showAddUser = false;
  includeInactive = false;
  selectedCompany: any = null;
  filteredUsers: any[] = [];
  searchTerm = '';
  sortOrder: 1 | -1 = 1; // 1 = ASC, -1 = DESC
  companies = [
    { label: 'Sara Plus', value: 'sara-plus', id: 1 },
    // Add more companies as needed, ensure each has label and value
  ];
  rowsOptions = [{ label: '10', value: 10 }, { label: '25', value: 25 }, { label: '50', value: 50 }];
  rows = 10; // Bind this to the table [rows]
  currentPage = 0;

  users: any[] = Array.from({ length: 30 }, (_, i) => {
    const isEven = i % 2 === 0;
    return {
      firstName: isEven ? 'Dave' : 'Cydcor',
      lastName: 'demo',
      email: isEven
        ? `dave.demo${i === 0 ? '' : i}@saraplus.com`
        : `cydcor.demo${i === 1 ? '' : i}@saraplus.com`,
      active: true
    };
  });

  ngOnInit(): void {
    // Set the page title for sticky header
    this.titleService.update({ title: 'Settings' });
    this.filteredUsers = [...this.users];
    this.applySort();
  }

  toggleSort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.applySort();
  }


   private applySort(): void {
    this.filteredUsers.sort((a, b) => {
      return (
        a.lastName
          .toLowerCase()
          .localeCompare(b.lastName.toLowerCase())
      ) * this.sortOrder;
    });
  }

  
  applySearch(): void {
    const term = this.searchTerm.trim().toLowerCase();

    this.filteredUsers = !term
      ? [...this.users]
      : this.users.filter(user => {
          const first = user.firstName.toLowerCase();
          const last = user.lastName.toLowerCase();
          const email = user.email.toLowerCase();
          const fullName = `${first} ${last}`;

          return (
            first.includes(term) ||
            last.includes(term) ||
            fullName.includes(term) ||
            email.includes(term)
          );
        });

    this.applySort(); 
  }


  openAddUser() {
  this.showAddUser = true;
  }

  closeAddUser() {
    this.showAddUser = false;
  }
  
  get totalPages(): number {
    return Math.ceil(this.filteredUsers.length / this.rows);
  }

  pagedUsers(): any[] {
    const start = this.currentPage * this.rows;
    return this.filteredUsers.slice(start, start + this.rows);
  }

  changePage(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.currentPage = page;
    }
  }

  changeRows(count: number) {
    this.rows = count;
    this.currentPage = 0;
  }

  onPageChange(pageIndex: number) {
    // Manual calculation: first index = target page index * rows per page
    this.currentPage = pageIndex;
    // If using PrimeNG table, also scroll to top or trigger change detection if needed
  }

  // Update your onRowsChange to reset pagination safely
  onRowsChange() {
    this.currentPage = 0;
    // If the table doesn't refresh, you can force a reference update
    this.filteredUsers = [...this.filteredUsers]; 
  }
}
